"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kOfferHeadline_png_1 = __importDefault(require("../../../../images/kesko/kOfferHeadline.png"));
var kPlusHeadline_png_1 = __importDefault(require("../../../../images/kesko/kPlusHeadline.png"));
var __1 = require("..");
var getHeadlineImage = function (isPlusOffer) { return (isPlusOffer ? kPlusHeadline_png_1.default : kOfferHeadline_png_1.default); };
var KeskoFeedHeadline = function (_a) {
    var styles = _a.styles, isPlusOffer = _a.isPlusOffer;
    var imageProps = {
        styles: styles,
        id: 'headline',
        src: getHeadlineImage(isPlusOffer),
        alt: 'headline'
    };
    return react_1.default.createElement(__1.Image, __assign({}, imageProps));
};
exports.default = KeskoFeedHeadline;
//# sourceMappingURL=KeskoFeedHeadline.js.map